import React from 'react';
import { Button, Dialog, Group } from '@economic/taco';
import { t, Trans } from '@lingui/macro';
import { useField } from 'react-final-form';
import { isValidEmail } from '~/app/shared/util/utilities/isValidEmail';
import { Field } from '~/app/shared/components/Form';

interface Props {
    prevStep: () => void;
    nextStep: () => void;
}

const ContactInformation = ({ prevStep, nextStep }: Props) => {
    const fieldFullName = useField('fullName');
    const fieldEmail = useField('email');
    const fieldPhone = useField('telephone');

    const onPrevClick = () => {
        prevStep();
    };

    const onNextClick = () => {
        fieldFullName.input.onBlur();
        fieldEmail.input.onBlur();
        fieldPhone.input.onBlur();

        if (fieldFullName.meta.invalid || fieldEmail.meta.invalid || fieldPhone.meta.invalid) {
            return;
        }

        nextStep();
    };

    const validateFullName = (value: string) => {
        const error = t`Full name is required`;

        const nameCount = value.trim().split(' ').length;
        const containsNumbers = /\d/.test(value);

        return !value || containsNumbers || nameCount < 2 ? error : undefined;
    };

    const validateEmail = (value: string) => (!isValidEmail(value) ? t`E-mail is required` : undefined);

    const validatePhone = (value: string) => (/^\+?\d{8,10}$/.test(value) ? undefined : t`Phone is required`);

    return (
        <>
            <Dialog.Title>
                <Trans>Your contact details</Trans>
            </Dialog.Title>

            <div className="flex mt-4">
                <Trans>Enter your contact details below. You will receive a confirmation email from pensopay.</Trans>
            </div>

            <div className="flex mt-6">
                <Field.Text required fieldClassName="w-full" label={t`Full name`} name="fullName" validate={validateFullName} />
            </div>

            <div className="flex mt-6">
                <Field.Text required fieldClassName="w-full" label={t`E-mail`} name="email" validate={validateEmail} />
            </div>

            <div className="flex mt-6">
                <Field.Text required fieldClassName="w-full" label={t`Phone number`} name="telephone" validate={validatePhone} />
            </div>

            <Group className="flex mt-4 justify-end">
                <Button onClick={onPrevClick}>
                    <Trans>Back</Trans>
                </Button>
                <Button appearance="primary" onClick={onNextClick}>
                    <Trans>Next</Trans>
                </Button>
            </Group>
        </>
    );
};

export default ContactInformation;
